import React, { useEffect, useState } from 'react'
import { SelectedStartUpDetails } from './SelectedStartUpDetails'
import { TableWithFields } from '@types'
import styled from '@emotion/styled'

interface Props {
  selectedColumns: { value: string; type: string }[]
  params: TableWithFields
}

export const DescriptiveCharts: React.FC<Props> = ({
  selectedColumns,
  params,
}) => {
  const [keys, setKeys] = useState<{ value: string; type: string }[]>([])

  useEffect(() => {
    //request per i campi possibili
    setKeys(params.keys)
  }, [params])

  return (
    <Container>
      {keys.map((key, index) => (
        <InfoContainer>
          {selectedColumns.find((selected) => selected.value === key.value) ? (
            <SelectedStartUpDetails
              dataCy={`bar-chart-${key.value}`}
              detail={key}
              key={index}
              params={params}
            />
          ) : (
            <></>
          )}
        </InfoContainer>
      ))}
    </Container>
  )
}

//region Style
const Container = styled.div`
  display: grid;
`
const InfoContainer = styled.div`
  height: auto;
  transition: all 5s;
`

//endregion
